var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 92,
    height: 92,
    rx: 46,
    fill: "#E7454C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_Hand - Checklist"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2182 39.4427L61.7035 30.9574C63.047 29.6139 63.047 27.3511 61.7035 26.0076C60.36 24.6641 58.0973 24.6641 56.7538 26.0076L42.9652 39.7962C42.2581 40.5033 41.1267 40.3619 40.4196 39.6548C40.0339 39.2691 39.882 38.7665 39.9638 38.2533L39.9953 38.0992C41.1267 33.8565 38.6518 29.5432 34.4092 28.4118L29.6716 46.1602C28.2862 51.7016 28.8686 57.9894 33.0805 62.4313L33.3485 62.7065C39.4296 68.7876 49.3291 68.7876 55.4103 62.7065L60.6429 57.4739C60.6429 50.6857 58.0266 44.251 53.2182 39.4427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9045 38.7355L55.6931 24.947C57.6224 23.0177 60.8349 23.0177 62.7642 24.947C64.6935 26.8763 64.6935 30.0887 62.7642 32.018L55.309 39.472L55.5766 39.7743C59.72 44.5462 62.0286 50.5976 62.1387 56.9935L62.1429 57.4739C62.1429 57.8717 61.9848 58.2532 61.7035 58.5345L56.4709 63.7671C49.804 70.434 38.9548 70.434 32.2739 63.753L31.9921 63.4634C27.7171 58.955 26.5607 52.419 28.2223 45.7733L32.96 28.0249C33.1736 27.2247 33.9954 26.749 34.7957 26.9624C39.8353 28.3063 42.7905 33.439 41.4649 38.3999L41.4451 38.4895C41.4371 38.5394 41.4426 38.5564 41.4803 38.5941C41.6642 38.7781 41.8479 38.7922 41.9045 38.7355ZM60.6429 29.8967C61.4006 29.139 61.4006 27.826 60.6429 27.0683C59.8852 26.3106 58.5722 26.3106 57.8145 27.0683L44.0259 40.8569C42.7188 42.1639 40.6481 42.0046 39.359 40.7154C38.6377 39.9942 38.324 39.0114 38.4943 37.9525L38.546 37.7127C39.3226 34.8003 38.012 31.8611 35.5167 30.4655L35.426 30.417L31.1268 46.524C29.7338 52.0962 30.629 57.4616 33.9216 61.1315L34.1552 61.3848L34.4092 61.6458C39.9045 67.1411 48.8543 67.1411 54.3496 61.6458L59.134 56.861L59.1261 56.5591C58.9077 50.6318 56.5694 45.0783 52.4759 40.8277L52.1576 40.5033C51.5718 39.9175 51.5718 38.9678 52.1576 38.382L60.6429 29.8967Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.8bc2c1cffbf135cdfeac63993c7f78d0.svg";
export { ForwardRef as ReactComponent };